import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/stages'),
    name: 'stages_dashboard_index',
    component: Index,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
